// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n

  // Enables the i18next backend
  .use(Backend)

  // Enable automatic language detection
  .use(LanguageDetector)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    //lng: 'en',
    backend: {
      /* translation file path */
      loadPath: '/assets/data/locales/{{lng}}/{{ns}}.json'
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru', 'az'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    ns: ['common', '1X'],
    defaultNS: 'common',
    detection: {
      checkWhitelist: true,
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng"
    }
  })

export default i18n
